export class ApplicationError extends Error {
  public override readonly name: string;

  constructor(message: string) {
    super(message);
    this.name = 'ApplicationError';
  }
}
